import RequestHandler from "./RequestHandler";

function EmailAPI() {
    const baseEmailAPI = "emails";

    async function contactSupport(body) {
        try {
            const result = await RequestHandler.post(
                `${baseEmailAPI}/contact-support`,
                body
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        contactSupport,
    };
}

export default EmailAPI();
